import { createContext } from "../helpers/React";
import SectionInterface from "../interfaces/SectionInterface";

export const { useContext: useSectionContext, Provider: SectionProvider } =
  createContext<SectionInterface>();
